/**
 * Support labels
 * Dynamic mapping from JSON based on current language
 * Uses getLanguage() to determine which locale to use
 */

import svSupport from '../locales/sv/support.json';
import enSupport from '../locales/en/support.json';
import svFollowUps from '../locales/sv/complaintFollowUps.json';
import enFollowUps from '../locales/en/complaintFollowUps.json';
import { getLanguage, type Language } from '@/utils/languageUtils';

/**
 * Support labels - dynamically uses current language
 */
export const supportLabels = (lang?: Language): Record<string, any> => {
  const currentLang = lang || getLanguage();
  const locale = currentLang === 'en' ? enSupport : svSupport;
  const followUpOptions = currentLang === 'en' ? enFollowUps : svFollowUps;
  return { ...locale, followUpOptions };
};

